import { addressBookOverlayStyles } from "@insite/content-library/Pages/AddressBookOverlay";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// AddressBookOverlay
addressBookOverlayStyles.drawer = {
    size: 450,
    closeButtonProps: {
        shape: "pill",
        buttonType: "solid",
        color: "common.background",
        size: 36,
    },
    cssOverrides: {
        drawerContent: css`
            overflow-y: initial;
            padding-bottom: 80px;
        `,
        drawerTitle: css`
            background: ${getColor("common.background")};
        `,
        drawerBody: css`
            background: ${getColor("common.background")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
};
